import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {FormActionForSchema, FormActionForSchemaVariables} from './__generated/FormActionForSchema';

type FormActionNode = FormActionForSchema['formAction'];

const FORM_ACTION_FRAGMENT = gql`
  fragment FormAction on FormActionNode {
    id
    actionMethodIdentifier
    name
    version
    invocationParameters {
      id
      name
      parameterTypeName
      schemaFieldId
      isRequired
      isMulti
      isSnapshot
      linkedSchemaId
      schemaFieldSelectorId
    }
  }
`;

export const INITIALIZE_FORM_DESIGNER_WITH_FORM_ACTION_QUERY = gql`
  query InitializeFormDesignerWithFormActionQuery($actionIdentifier: StrictString!, $schemaId: StrictString!)
  @skipAudit
  @engComponent(name: FORMS) {
    processTaskSchemasSupportingPlatformFeature(platformFeature: SCHEMA_CONFIG) {
      id
      name
      fields
      allFields
      executionType
      canSetAssigneeOnTaskCreation
    }
    formAction(actionIdentifier: $actionIdentifier, schemaId: $schemaId) {
      ... on FormActionNode {
        ...FormAction
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${FORM_ACTION_FRAGMENT}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_ALL_PROCESS_TASK_SCHEMAS = gql`
  query FormDesignerProcessTaskSchemasQuery @skipAudit @engComponent(name: FORMS) {
    processTaskSchemasSupportingPlatformFeature(platformFeature: SCHEMA_CONFIG) {
      id
      name
    }
  }
`;

export const FORM_ACTION_QUERY = gql`
  query FormActionForSchema($actionIdentifier: StrictString!, $schemaId: StrictString!)
  @skipAudit
  @engComponent(name: FORMS) {
    formAction(actionIdentifier: $actionIdentifier, schemaId: $schemaId) {
      ... on FormActionNode {
        ...FormAction
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${FORM_ACTION_FRAGMENT}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export async function fetchFormActionForSchema(
  actionIdentifier: string,
  schemaId: string
): Promise<FormActionNode> {
  const result = await doQuerySafe<FormActionForSchema, FormActionForSchemaVariables>(
    {query: FORM_ACTION_QUERY},
    {variables: {actionIdentifier, schemaId}, fetchPolicy: 'cache-first'}
  );
  return result.formAction;
}
